import posthog from "posthog-js";
import { Cookie } from "utils/cookieHelper";

export function identifyWithPid(pid, personProps) {
  if (pid == null || pid === "") return false;
  if (!posthog?.__loaded) return false;

  const id = String(pid);

  const alreadyIdentified =
    posthog.get_property?.("$user_id") === id ||
    posthog.get_distinct_id?.() === id;
  if (alreadyIdentified) return false;

  const props = { ...personProps };
  if (props.ojj == null) {
    const ojj = new Cookie().get("ojj");
    if (ojj != null) props.ojj = ojj;
  }
  if (props.ojj == null) delete props.ojj;

  try {
    posthog.identify(id, props);
    return true;
  } catch (_error) {
    return false;
  }
}
